import { enSG as common } from './features/common'
import { enSG as login } from './features/login'
import Translation from './types'

export const enSG: Translation = {
  translation: {
    features: {
      common,
      login,
    },
  },
}
